import React from 'react';
import { useState } from 'react';
import { Container, Row, Col, Card, Button, Modal } from 'react-bootstrap';
import card1img from '../assest/images/packages/img6.png';
import card2img from '../assest/images/packages/img8.png';
import card3img from '../assest/images/packages/img7.png';
import card4img from '../assest/images/packages/img11.png';
import card5img from '../assest/images/packages/img5.png';
import card6img from '../assest/images/packages/img2.png';
import card7img from '../assest/images/packages/img10.png';
import card8img from '../assest/images/packages/img1.png';
import card9img from '../assest/images/packages/img9.png';
import card10img from '../assest/images/packages/img3.png';
import card11img from '../assest/images/packages/img3.png';
import card12img from '../assest/images/packages/img12.png';
import '../package.css';

function Packages() {

  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageClick = (image) => {
    setSelectedImage(image);
    setShowModal(true);
  };
  const packages =[
    {
      id:1,
      title:<b> Bentota | Colombo</b>,
      text:"Savor the tranquility of Bentota and the sophistication of Colombo with our expertly curated package",
      image:card1img
    },
    {
      id:2,
      title: <b>Kandy | Bentota | Colombo</b>,
      text:"Culture, comfort, and coastal bliss all in one exquisite Sri Lankan journey.",
      image:card2img

    },
    {
      id:3,
      title:<b>Kandy | Bentota | Colombo  5N/6D</b>,
      text:"From sacred cities to sandy shores  explore, relax, and experience Sri Lanka in comfort and style.",
      image:card3img
    },
    {
      id:4,
      title:<b>Kandy | NuwaraEliya | Bentota | Colombo </b>,
      text:"From tea gardens to tropical shores  discover the best of Sri Lanka in one seamless journey",
      image:card4img
    },
    {
      id:5,
      title:<b>RAMAYANA Journey 5N/6D </b>,
      text:"Walk through history, faith, and nature — an unforgettable Sri Lankan experience.",
      image:card5img
    },
    {
      id:6,
      title:<b>Kandy | NuwaraEliya | Ella | Bentota | Colombo </b>,
      text:"One island, endless beauty — discover Sri Lanka’s most breathtaking destinations in a single journey",
      image:card6img

    },
    {
      id:7,
      title:<b>Mirissa | Hikkaduwa | Galle | Bentota  5N/6D</b>,
      text:"Golden sands, blue seas, and timeless beauty  your perfect tropical escape awaits",
      image:card7img

    },
    {
      id:8,
      title:<b>Sigiriya | Kandy| Nuwara Eliya | Ella | Yala | Colombo 7N/8D</b>,
      text:"into Sri Lanka’s ancient past — explore sacred cities, royal palaces, and cultural treasures across the island’s timeless heartlands",
      image:card8img
      
    },
    {
      id:9,
      title:<b>Anuradhapura |Sigiriya | Kandy  5N/6D</b>,
      text:"Experience ancient wonders in comfort — where timeless culture meets modern hospitality",
      image:card9img
    },
    {
      id:10,
      title:<b>Nuwara Eliya | Ella | Galle | Bentota  5N/6D</b>,
      text:"One island, endless beauty — discover Sri Lanka’s most breathtaking destinations in a single journey",
      image:card10img
    },
    {
      id:11,
      title:<b>Sigiriya | Kandy | Nuwara Eliya | Ella | Yala | Bentota  7N/8D</b>,
      text:"From ancient rocks to misty hills — Sri Lanka in 7 nights, 8 days",
      image:card11img
    },
    {
      id:12,
      title:<b>West coastle |south coastle | Hill country | Cultural Trinagle 14N/15D</b>,
      text:"From sun-kissed beaches to misty hills and ancient wonders - explore the West Coast, South Coast, Hill Country, and Cultural Triangle! ",
      image:card12img
    }

  ]


   return (
    <section id="packages" className="py-5 bg-light">
      <Container>
        <h2 className="text-center mb-4 fw-bold">Tour Packages</h2>
        <Row className="g-4">
          {packages.map((pkg) => (
            <Col key={pkg.id} md={4} lg={3}>
              <Card className="h-100 shadow-sm border-0">
               <div className="card-img-hover">
 <Card.Img
  variant="top"
  src={pkg.image}
  alt={pkg.title}
  style={{ height: '200px', objectFit: 'cover', cursor: 'pointer' }}
  onClick={() => handleImageClick(pkg.image)}
/>

</div>
                <Card.Body className="d-flex flex-column">
                  <Card.Title>{pkg.title}</Card.Title>
                  <Card.Text className="flex-grow-1">{pkg.text}</Card.Text>


               <Button
                 className="rounded-pill px-4 py-2 shadow-sm book-btn"
                onClick={() => {
                const url = `https://mail.google.com/mail/?view=cm&fs=1&to=info@escapiotravels.com&su=${encodeURIComponent(
        'Contact about Escapio Travels'
                )}&body=${encodeURIComponent(
                'Hello, I would like to know more about your travel packages.'
                )}`;
                window.open(url, "_blank", "noopener,noreferrer");
                }}
                >
                 Book Now
                </Button>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
       <Modal show={showModal} onHide={() => setShowModal(false)} centered size="lg">
        <Modal.Body className="p-0">
          <img
            src={selectedImage}
            alt="Full View"
            style={{ width: '100%', height: 'auto', borderRadius: '5px' }}
          />
        </Modal.Body>
      </Modal>
    </section>
  );
}


export default Packages;
